var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plotly_screen"},[_c('div',{staticClass:"plotly",attrs:{"id":_vm.propsid},on:{"mouseover":function($event){return _vm.$emit('hover')},"mouseleave":function($event){return _vm.$emit('unhover')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }